/* eslint-disable */
require('./admin')
require('./alert-circle')
require('./allianz')
require('./arrow_down')
require('./arrow_dropdown')
require('./arrow_right')
require('./calendar')
require('./camera-create')
require('./cart')
require('./check-mark')
require('./chevron-bottom')
require('./close-modal')
require('./close')
require('./coins')
require('./delete-trash')
require('./delete')
require('./dossier')
require('./edit')
require('./empty-damage')
require('./fence')
require('./filePrice')
require('./house')
require('./ico-ajouter')
require('./ico-bath')
require('./ico-bedroom')
require('./ico-camera-flash-active')
require('./ico-camera')
require('./ico-ceiling')
require('./ico-chevron')
require('./ico-cleaning')
require('./ico-confirmed')
require('./ico-cp')
require('./ico-crystal')
require('./ico-date')
require('./ico-delete')
require('./ico-dinning')
require('./ico-documents')
require('./ico-dommages')
require('./ico-donnes-du-dossier')
require('./ico-door')
require('./ico-dossiers')
require('./ico-download')
require('./ico-edit')
require('./ico-exterior')
require('./ico-fence')
require('./ico-file')
require('./ico-flash')
require('./ico-floor')
require('./ico-garage')
require('./ico-groupe-garantie')
require('./ico-hall')
require('./ico-house')
require('./ico-info')
require('./ico-inscrire-dossier')
require('./ico-kitchen')
require('./ico-lang')
require('./ico-logo-multiasistencia')
require('./ico-materialtype')
require('./ico-mobilier')
require('./ico-mobiliere')
require('./ico-moins')
require('./ico-montant')
require('./ico-nav')
require('./ico-new-plus')
require('./ico-notification-ok_Mesa de trabajo 1')
require('./ico-notification')
require('./ico-numero-police')
require('./ico-others')
require('./ico-pencil-create')
require('./ico-pieces-touchees')
require('./ico-plus')
require('./ico-question')
require('./ico-reference-dossier')
require('./ico-regarde')
require('./ico-siren')
require('./ico-suprimmer')
require('./ico-surface')
require('./ico-switch')
require('./ico-toilet')
require('./ico-trash')
require('./ico-view-modes')
require('./ico-wall')
require('./ico-water-electricity')
require('./ico-window')
require('./Illustration')
require('./Info')
require('./ko')
require('./logoMa')
require('./logout')
require('./message')
require('./minus')
require('./mobiliere')
require('./more-vertical')
require('./ok')
require('./phone')
require('./plus')
require('./rangeLabel')
require('./recherche')
require('./search-mobilier')
require('./search')
require('./surface')
require('./telf')
require('./tools')
require('./trash')
require('./trash2')
require('./warrantyFurniture')
require('./warrantyGlass')
require('./warrantyStorm')
require('./warrantyTheft')
require('./warrantyWater')
require('./water')
require('./x')
